/* src/app/features/parametrizacao/parametrizacao-impedimento/parametrizacao-impedimento.component.scss */
#pointer :hover {
  cursor: pointer;
}
.head-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/*# sourceMappingURL=parametrizacao-impedimento.component.css.map */
